import {
	FETCH_PODCASTS,
	FETCH_PODCAST,
	CREATE_PODCAST,
	UPDATE_PODCAST,
	DELETE_PODCAST,
	CLEAR_PODCAST,
	CLEAR_PODCASTS,
} from '../actions/actionTypes';

const preState = {
	podcasts: [],
	podcast: {},
	pinned: {},
};

const findPinnedPodcast = podcasts => {
	const pinnedArr = podcasts.filter(podcast => podcast.pinned);
	return pinnedArr[0] || {};
};

export const podcastsReducer = (state = preState, action) => {
	Object.freeze(state);
	const stateDup = { ...state };
	const { type, podcasts, podcast, podcastID } = action;

	switch (type) {
		case FETCH_PODCASTS:
			const pinned = findPinnedPodcast(podcasts);
			return { ...stateDup, podcasts: [...podcasts], pinned };
		case FETCH_PODCAST:
			return { ...stateDup, podcast };
		case CREATE_PODCAST:
			return { ...stateDup, podcasts: [...stateDup.podcasts, podcast], podcast };
		case UPDATE_PODCAST:
			const podcastsAfterUpdate = stateDup.podcasts.map(pod =>
				pod.id === podcast.id ? podcast : pod
			);
			const pinnedAfterUpdate = findPinnedPodcast(podcastsAfterUpdate);
			return {
				...stateDup,
				podcasts: podcastsAfterUpdate,
				podcast,
				pinned: pinnedAfterUpdate,
			};
		case DELETE_PODCAST:
			if (stateDup.podcast && stateDup.podcast.id === podcastID) stateDup.podcast = {};
			const podcastsAfterDelete = stateDup.podcasts.filter(pod => pod.id !== podcastID);
			const pinnedAfterDelete = findPinnedPodcast(podcastsAfterDelete);
			return { ...stateDup, podcasts: podcastsAfterDelete, pinned: pinnedAfterDelete };
		case CLEAR_PODCASTS:
			return { ...preState };
		case CLEAR_PODCAST:
			return { ...stateDup, podcast: {} };
		default:
			return stateDup;
	}
};

export default podcastsReducer;
